'use client';


export function  GamesHeader() {
  return (
    <header className="flex flex-col lg:flex-row lg:items-center justify-between gap-6">
      <div>
        <h2 className="text-3xl font-bold">Hey, Ade Ronke! </h2>
        <p className="text-muted-foreground mt-1">Ready to explore your future today?</p>
      </div>
      <div className="flex items-center gap-4">
        {/* <div className="relative flex-1 lg:w-80">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground h-5 w-5" />
          <Input
            className="pl-12 pr-4 py-3 rounded-full bg-white border-slate-200"
            placeholder="Search games..."
            type="text"
          />
        </div> */}
  
      </div>
    </header>
  );
}
